const getSelectedFilters = ({ report: { filters } }, dataKey) => ({
  selectedFilters: filters.active.selected[dataKey],
  selectedFiltersUrlParams: filters.active.urlParams[dataKey],
});

export default getSelectedFilters;
